/**
 * Format number as Indian Rupee (INR)
 * @param {number} amount - The amount to format
 * @returns {string} Formatted string with ₹ symbol
 */
export const formatINR = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '₹0';
  }
  
  // Convert to number if it's a string
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  
  // Format with Indian number system (lakhs, crores)
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
    minimumFractionDigits: 0
  }).format(numAmount);
};

/**
 * Format number as Indian Rupee without currency symbol (for input fields)
 * @param {number} amount - The amount to format
 * @returns {string} Formatted string without ₹ symbol
 */
export const formatINRNumber = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0';
  }
  
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  
  return new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0
  }).format(numAmount);
};

/**
 * Parse Indian formatted number string to number
 * @param {string} formattedString - Formatted string (e.g., "1,23,456.78")
 * @returns {number} Parsed number
 */
export const parseINR = (formattedString) => {
  if (!formattedString) return 0;
  // Remove commas and parse
  const cleaned = formattedString.toString().replace(/,/g, '');
  return parseFloat(cleaned) || 0;
};

